module.exports = __webpack_public_path__ + "static/media/rawkkim-KKz6NgO69yQ-unsplash.2edd5a08.jpg";